import { Color } from "@starrez/starryui";
import styled from "styled-components";

export interface IWizardTabDivProps {
    Hidden: boolean;
}

export interface IWizardPanelDivProps {
    IsSaving: boolean;
}

export const WrapperDiv = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
`;

export const HeaderDiv = styled.div`
    border-bottom: 1px solid ${Color.Grey.G20};
    display: flex;
    flex: 0;
    flex-direction: column;
    padding: 0 1px;
`;

export const ContentDiv = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    z-index: 1;
    min-height: 0;
`;

export const WizardPanelDiv = styled.div<IWizardPanelDivProps>`
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    min-height: 0;
    overflow-y: auto;
    ${(props) => props.IsSaving && `
        pointer-events: none;
        opacity: 0.4;
    `}
`;

export const WizardTabDiv = styled.div<IWizardTabDivProps>`
    display: flex;
    flex: 1;
    flex-direction: column;
    ${(props) => props.Hidden && `
        display: none;
    `}
`;

export const WizardForm = styled.form`
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 14px;
    min-height: 0;
`;

export const WizardLoadingDiv = styled.div`
    font-size: 18px;
    display: flex;
    flex: 1;
    flex-direction: column;
    position: relative;
`;
